if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              this.updateCartCountBubble();
              this.showAddToCartToast(response);
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      showAddToCartToast(response) {
        document.querySelector('.bsi-cart-toast')?.remove();

        const toast = document.createElement('div');
        toast.className = 'bsi-cart-toast';
        toast.setAttribute('role', 'dialog');
        toast.setAttribute('aria-modal', 'false');
        toast.setAttribute('aria-label', 'Warenkorb-Vorschau');

        const content = document.createElement('div');
        content.className = 'bsi-cart-toast__content';

        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'bsi-cart-toast__close';
        closeButton.setAttribute('aria-label', 'Warenkorb-Vorschau schließen und weiter shoppen');
        closeButton.textContent = '×';
        closeButton.addEventListener('click', () => toast.remove());

        const header = document.createElement('div');
        header.className = 'bsi-cart-toast__header';

        const copy = document.createElement('div');
        copy.className = 'bsi-cart-toast__copy';

        const headline = document.createElement('p');
        headline.className = 'bsi-cart-toast__headline';
        headline.textContent = 'Zum Warenkorb hinzugefügt';

        const itemTitle = document.createElement('p');
        itemTitle.className = 'bsi-cart-toast__item';
        itemTitle.textContent = response?.product_title || response?.title || 'Der Artikel wurde hinzugefügt.';

        copy.append(headline, itemTitle);
        header.append(copy, closeButton);

        const preview = document.createElement('div');
        preview.className = 'bsi-cart-toast__preview';
        preview.textContent = 'Warenkorb wird geladen …';

        const footer = document.createElement('div');
        footer.className = 'bsi-cart-toast__footer';

        const total = document.createElement('div');
        total.className = 'bsi-cart-toast__total';
        total.innerHTML = '<span>Zwischensumme</span><strong>–</strong>';

        const actions = document.createElement('div');
        actions.className = 'bsi-cart-toast__actions';

        const cartLink = document.createElement('a');
        cartLink.href = window.routes.cart_url;
        cartLink.className = 'button bsi-cart-toast__cart-link';
        cartLink.textContent = 'Warenkorb anzeigen';

        const continueButton = document.createElement('button');
        continueButton.type = 'button';
        continueButton.className = 'button button--secondary bsi-cart-toast__continue';
        continueButton.textContent = 'Weiter shoppen';
        continueButton.addEventListener('click', () => toast.remove());

        actions.append(cartLink, continueButton);
        footer.append(total, actions);
        content.append(header, preview, footer);
        toast.append(content);
        document.body.append(toast);

        fetch(`${window.routes.cart_url}.js`)
          .then((cartResponse) => cartResponse.json())
          .then((cart) => this.renderCartToastPreview(preview, total, cart))
          .catch(() => {
            preview.textContent = 'Der Artikel liegt im Warenkorb.';
          });
      }

      renderCartToastPreview(preview, total, cart) {
        preview.innerHTML = '';

        const items = Array.isArray(cart?.items) ? cart.items.slice(0, 4) : [];
        if (!items.length) {
          preview.textContent = 'Der Artikel liegt im Warenkorb.';
          return;
        }

        const list = document.createElement('div');
        list.className = 'bsi-cart-toast__items';

        items.forEach((item) => {
          const row = document.createElement('div');
          row.className = 'bsi-cart-toast__preview-item';

          const imageWrap = document.createElement('div');
          imageWrap.className = 'bsi-cart-toast__preview-image';

          if (item.image) {
            const image = document.createElement('img');
            image.src = this.resizeShopifyImage(item.image, '120x');
            image.alt = item.product_title || item.title || '';
            image.loading = 'lazy';
            image.width = 60;
            image.height = 60;
            imageWrap.appendChild(image);
          }

          const info = document.createElement('div');
          info.className = 'bsi-cart-toast__preview-info';

          const title = document.createElement('p');
          title.className = 'bsi-cart-toast__preview-title';
          title.textContent = item.product_title || item.title || 'Artikel';

          const meta = document.createElement('p');
          meta.className = 'bsi-cart-toast__preview-meta';
          meta.textContent = `${item.quantity} × ${this.formatCartMoney(item.final_price || item.price, cart.currency)}`;

          info.append(title, meta);

          const linePrice = document.createElement('strong');
          linePrice.className = 'bsi-cart-toast__preview-price';
          linePrice.textContent = this.formatCartMoney(item.final_line_price || item.line_price, cart.currency);

          row.append(imageWrap, info, linePrice);
          list.appendChild(row);
        });

        if (cart.items.length > items.length) {
          const more = document.createElement('p');
          more.className = 'bsi-cart-toast__more';
          more.textContent = `+ ${cart.items.length - items.length} weitere Artikel im Warenkorb`;
          list.appendChild(more);
        }

        preview.appendChild(list);
        total.innerHTML = `<span>${cart.item_count} ${cart.item_count === 1 ? 'Artikel' : 'Artikel'}</span><strong>${this.formatCartMoney(cart.total_price, cart.currency)}</strong>`;
      }

      formatCartMoney(cents, currency = 'EUR') {
        const amount = (Number(cents) || 0) / 100;
        try {
          return new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(amount);
        } catch (_error) {
          return `${amount.toFixed(2).replace('.', ',')} €`;
        }
      }

      resizeShopifyImage(src, size) {
        if (typeof src !== 'string') return src;
        return src.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, `_${size}$1$2`);
      }

      updateCartCountBubble() {
        fetch(`${window.routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => {
            const cartIcon = document.querySelector('#cart-icon-bubble');
            if (!cartIcon || !cart) return;

            let bubble = cartIcon.querySelector('.cart-count-bubble');
            if (!bubble && cart.item_count > 0) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble';
              cartIcon.appendChild(bubble);
            }

            if (!bubble) return;

            if (cart.item_count > 0) {
              bubble.innerHTML = '';
              if (cart.item_count < 100) {
                const visibleCount = document.createElement('span');
                visibleCount.setAttribute('aria-hidden', 'true');
                visibleCount.textContent = cart.item_count;
                bubble.appendChild(visibleCount);
              }

              const screenReaderCount = document.createElement('span');
              screenReaderCount.className = 'visually-hidden';
              screenReaderCount.textContent = `${cart.item_count} Artikel im Warenkorb`;
              bubble.appendChild(screenReaderCount);
            } else {
              bubble.remove();
            }
          })
          .catch((error) => console.error(error));
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
